// extracted by mini-css-extract-plugin
export default {"list":"nav_list__XSdsQ","menuIcon":"nav_menuIcon__ef1ER"};